import APIs from "../../apiUrl";

const MajorCategoriesService = {
  getAllMajorCategories: async ({ page = 1, limit = 6 }) => {
    try {
      const response = await APIs.get(`/get_all_major_category/${page}/${limit}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default MajorCategoriesService;
